<template>
    <div
        class="lead-table-footer | sticky bottom-0 bg-white border-t border-grey-200 p-4 rounded-b z-10 | md:px-6 | print:relative"
    >
        <el-pagination
            :layout="paginationLayout"
            :pager-count="5"
            :background="true"
            :current-page="pagination.currentPage"
            :page-size="Number.parseInt(pagination.perPage, 10)"
            :page-sizes="[10, 25, 50, 100, 200]"
            :total="pagination.total"
            @update:current-page="handleCurrentPageChange"
            @update:page-size="handlePerPageChange"
            v-if="hasPagination"
        />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'pinia';

    import { useDashboardStore } from '@/store/modules/dashboard/store.js';
    import { useUserStore } from '@/store/modules/user/store.js';
    import { useEventBus } from '@/hooks/useEventBus.ts';
    import Pagination from '../../mixins/Pagination.js';

    const { emit } = useEventBus();

    export default {
        mixins: [Pagination],

        computed: {
            ...mapState(useDashboardStore, {
                pagination: 'pagination',
                dashboardType: 'dashboardType',
            }),

            hasPagination() {
                return [
                    this.pagination.currentPage,
                    this.pagination.perPage,
                    this.pagination.total,
                ].every((value) => value !== undefined && value !== null);
            },
        },

        methods: {
            ...mapActions(useUserStore, ['updateSession']),
            ...mapActions(useDashboardStore, ['updatePagination']),

            handlePerPageChange(perPage) {
                if (perPage === Number.parseInt(this.pagination.perPage, 10)) return;
                this.updatePerPage(perPage);
            },

            handleCurrentPageChange(page) {
                if (page === this.pagination.currentPage) return;
                this.updateCurrentPage(page);
            },

            updatePerPage(perPage) {
                this.updatePagination('perPage', perPage);
                emit('update-inventory-pagination', {
                    page: 1,
                    perPage,
                });

                if (perPage <= 50) {
                    this.updateSession('per_page', perPage);
                }
            },

            updateCurrentPage(page) {
                this.updatePagination('currentPage', page);
                emit('update-inventory-pagination', { page });
            },
        },
    };
</script>

<style lang="less">
    .el-pagination button.btn-next {
        margin-right: 0px !important;
    }
</style>
